import safeFetch from '../extenstions/safeFetch';
import url from '../extenstions/url';
import parseResponseTime from '../extenstions/parseResponseTime';

export default (secret, round, type, status, page, setTasks) =>
    safeFetch(`${url.tasks.get}?secret=${secret}&round=${round}&type=${type}&status=${status}&offset=${10 * page}&count=10`)
        .then((tasks) => tasks
            .map(parseResponseTime))
        .then(setTasks);
